require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-david-gardner-grad-dealtapp-cofounder.json") })
        }
      }, "path---blog-david-gardner-grad-dealtapp-cofounder");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-david-gardner-grad-dealtapp-cofounder!./.cache/json/blog-david-gardner-grad-dealtapp-cofounder.json
// module id = 776
// module chunks = 231608221292675